import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'

import { addReferral } from '#/entities/user-account/model/user-type-slice'
import { NextPageWithLayout } from '#/pages/_app'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

export interface ReferralRegisterProps {
	email: string
}

const REFERRAL_BLOCKED_MESSAGE =
	'Вы не можете повторно зарегистрироваться по реферальной ссылке или стать рефералом после регистрации.'

const ReferralRegister: NextPageWithLayout<ReferralRegisterProps> = ({ email }) => {
	const dispatch = useDispatch()
	const { push, replace } = useRouter()
	const { status } = useSession()
	const { showMessage } = useShowDataStore()

	useEffect(() => {
		if (status === 'loading') return

		if (status === 'authenticated') {
			showMessage(REFERRAL_BLOCKED_MESSAGE, 'error')
			replace('/')
			return
		}

		localStorage.setItem('referral', email)
		dispatch(addReferral(email))
		push('/register')
	}, [status, email, dispatch, push, replace, showMessage])

	return (
		<Box sx={{ width: '100vw', height: '100vh', background: '#4b4b4b', position: 'relative' }}>
			<CircularProgress
				size={50}
				thickness={5}
				sx={{
					color: '#7F7DF3',
					position: 'absolute',
					top: '40%',
					right: 0,
					left: 0,
					margin: '0 auto',
				}}
			/>
		</Box>
	)
}

export default ReferralRegister
